export default __webpack_public_path__ + "static/media/emoji_angry.23ba0b44.svg";